import { createFileRoute } from '@tanstack/react-router';

import { rightPaneEnabledAtom } from '@/components/right-pane/right-pane.state';
import { jotaiStore } from '@/providers/jotai/jotai-store';

export const Route = createFileRoute('/$org/$agent/alarms')({
  beforeLoad: () => {
    jotaiStore.set(rightPaneEnabledAtom, false);
  },
});
